<ng-container *ngIf="!view_team_details">
    <ng-container *ngIf="advisor_teams_list_loaded">
        <div class="page-section">
            <div class="page-action-section">
                <button class="page-action" (click)="openCreateAdvisorTeamModal(selected_advisor_team, 'Add')">Add New Advisor Team</button>
            </div>
            <div class="page-zero-state" *ngIf="advisor_teams_list.length == 0">
                <span>No Advisor Teams Found</span>
            </div>
            <div class="new-table-v2-overflow" *ngIf="advisor_teams_list.length != 0">
                <table class="new-table-v2">
                    <thead>
                        <tr>
                            <th appColumnResizable>Actions</th>
                            <th appColumnResizable>S. No</th>
                            <th appColumnResizable>Team Name</th>
                            <th appColumnResizable>Primary Advisor</th>
                            <th appColumnResizable>Primary Advisor Share</th>
                            <th appColumnResizable>Status</th>
                            <th appColumnResizable>Description</th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngFor=" let data of advisor_teams_list | paginate : { id: 'advisor-teams-table', itemsPerPage: 10, currentPage: current_page, totalItems: advisor_teams_list.length}; let index = index">
                            <tr>
                                <!-- <td *ngIf="selected_role == 1"> -->
                                <td>
                                    <img src="assets/view-tasks.png" class="page-table-actions" (click)="viewAdvisorTeam(data, 'View')" />
                                    <img src="assets/edit-client.png" class="page-table-actions" (click)="openCreateAdvisorTeamModal(data, 'Edit')" />
                                    <!-- Remove Delete <img src="assets/delete-icon.png" class="page-table-actions" class="page-table-actions" (click)="removeExistingRecord(data)" /> -->
                                </td>
                                <td>
                                    <span *ngIf="current_page == 1">{{ index + 1 }}</span>
                                    <span *ngIf="current_page != 1">{{((current_page - 1) * 10) + (index + 1) }}</span>
                                </td>
                                <td [matTooltip]="data.name">{{ data.name }}</td>
                                <td [matTooltip]="data.primary_advisor_name">{{ data.primary_advisor_name }}</td>
                                <td [matTooltip]="data.share_percentage">{{ data.share_percentage }}</td>
                                <td>
                                    <mat-slide-toggle
                                        [(ngModel)]="data.is_active"
                                        [checked]="data.is_active == true"
                                        (change)="changeStatus(data)"
                                    ></mat-slide-toggle>
                                </td>
                                <td [matTooltip]="data.description">{{ data.description }}</td>
                            </tr>
                        </ng-container>
                    </tbody>
                </table>
            </div>
            <div style="margin-top: 24px">
                <pagination-controls id="advisor-teams-table" (pageChange)="current_page = $event" style="text-align: right; position: relative; top: 6px" ></pagination-controls>
            </div>
        </div>
    </ng-container>

    <ng-container *ngIf="!advisor_teams_list_loaded">
        <app-loader [loading_text]="'Loading Advisor Teams'"></app-loader>
    </ng-container>
</ng-container>

<ng-container *ngIf="view_team_details">
    <ng-container *ngIf="selected_view_team_data_loaded">
        <div class="page-section">
            <div class="page-heading-details-section">
                <div>
                    <img src="assets/back.png" class="page-back-icon" (click)="back()" />
                    <span class="page-heading">{{selected_advisor_team.name}}</span>
                </div>
            </div>
            <div class="team-description" *ngIf="selected_advisor_team.description != '' && selected_advisor_team.description != null">
                <span>{{selected_advisor_team.description}}</span>
            </div>
            <div class="team-members-section">
                <div class="each-team-member-section" style="background: #DFE9F4;">
                    <div style="text-align: right;">
                        <span class="primary-tag">Primary Advisor</span>
                    </div>
                    <p class="each-team-member-share">{{selected_advisor_team.share_percentage}}%</p>
                    <p class="each-team-member-name">{{selected_advisor_team.primary_advisor_name}}</p>
                </div>
                <div class="each-team-member-section" *ngFor="let team_member of selected_advisor_team.team_members">
                    <p class="each-team-member-share">{{team_member.share_percentage}}%</p>
                    <p class="each-team-member-name">{{team_member.advisor_name}}</p>
                </div>
            </div>

            <div class="new-table-v2-overflow">
                <div class="new-table-heading-section">
                    <span>Advisor Team Prospects</span>
                    <div class="new-table-actions ml-4">
                        <div class="each-action-section search-input-section" *ngIf="show_search">
                            <input type="text" placeholder="Search" class="search-input" [(ngModel)]="search_key" (input)="current_pagination_page = 1; viewAdvisorTeam(selected_advisor_team, selected_advisor_team_type)" />
                            <span class="search-input-close" (click)=" show_search = false; search_key = '';current_pagination_page = 1; viewAdvisorTeam(selected_advisor_team, selected_advisor_team_type)">&times;</span >
                        </div>
                        <div class="each-action-section search-icon" *ngIf="!show_search" (click)="show_search = true">
                            <img src="assets/search.png" class="button-icon" />
                            <span>Search</span>
                        </div>
                        <div class="each-action-section dynamic-columns-section">
                            <img src="assets/column-filter.png" class="button-icon" (click)="show_toggle_columns = !show_toggle_columns" />
                            <div class="dynamic-columns" *ngIf="show_toggle_columns">
                                <div class="dynamic-column-heading-section">
                                    <span>Filter Columns</span>
                                    <span class="columns-close" (click)="show_toggle_columns = false" >&times;</span>
                                </div>
                                <div class="dynamic-column-content">
                                    <div class="each-column-section" *ngFor="let column of table_columns">
                                        <mat-checkbox [checked]="column.checked == true" (change)="column.checked = !column.checked" >{{ column.name }}</mat-checkbox>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="alphabets-filter-section">
                        <p class="new-each-filter-alphabet" [ngClass]="{ 'new-filter-alphabet-selected': alphabet == selected_alphabet }" *ngFor="let alphabet of alphabets_array" (click)="current_pagination_page = 1; selected_alphabet = alphabet; viewAdvisorTeam(selected_advisor_team, selected_advisor_team_type) " style="margin-bottom: 8px !important"> {{ alphabet }}</p>
                        <p class="clear-filter-alphabet" (click)=" current_pagination_page = 1; selected_alphabet = ''; viewAdvisorTeam(selected_advisor_team, selected_advisor_team_type)" > Clear</p>
                    </div>
                    <div class="move-records-section">
                        <button class="move-records-button" (click)="openMoveRecordModal()">Unassign Prospects</button>
                        <span class="page-modal-input-label" *ngIf="selected_table_data.length > 0">{{selected_table_data.length}} Record(s) Selected</span>
                        <span class="page-modal-input-error" *ngIf="selected_table_data.length == 0 && move_record_error">Please select one or more records</span>
                    </div>

                    <div class="new-table-v2-overflow">
                        <table class="new-table-v2">
                            <thead>
                                <tr>
                                    <th appColumnResizable>
                                        <div class="record-selection-section">
                                            <mat-checkbox [checked]="is_selected" (change)="selectAll($event)"></mat-checkbox>
                                        </div>
                                        Actions
                                    </th>
                                    <ng-container *ngFor="let column of table_columns" [ngSwitch]="column.key">
                                        <ng-container *ngSwitchCase="'trigger'">
                                            <th appColumnResizable *ngIf="column.checked" style="width: 350px;">{{ column.name }}</th>
                                        </ng-container>
                                        <ng-container *ngSwitchCase="'trigger_condition'">
                                            <th appColumnResizable *ngIf="column.checked" style="width: 500px;">{{ column.name }}</th>
                                        </ng-container>

                                        <ng-container *ngSwitchCase="'opportunity'">
                                            <th appColumnResizable *ngIf="column.checked" style="width: 250px;">{{ column.name }}</th>
                                        </ng-container>
                                        <ng-container *ngSwitchCase="'total_estimated_loss'">
                                            <th appColumnResizable *ngIf="column.checked" style="width: 250px;">{{ column.name }}</th>
                                        </ng-container>
                                        <ng-container *ngSwitchCase="'predicted_wallet_share_growth'">
                                            <th appColumnResizable *ngIf="column.checked" style="width: 250px;">{{ column.name }}</th>
                                        </ng-container>
                                        <ng-container *ngSwitchCase="'predicted_closure_days'">
                                            <th appColumnResizable *ngIf="column.checked" style="width: 250px;">{{ column.name }}</th>
                                        </ng-container>
                                        <ng-container *ngSwitchCase="'recommended_products'">
                                            <th appColumnResizable *ngIf="column.checked" style="width: 250px;">{{ column.name }}</th>
                                        </ng-container>
                                        <ng-container *ngSwitchCase="'preferred_channel'">
                                            <th appColumnResizable *ngIf="column.checked" style="width: 250px;">{{ column.name }}</th>
                                        </ng-container>

                                        <ng-container *ngSwitchDefault>
                                            <th appColumnResizable *ngIf="column.checked">{{ column.name }}</th>
                                        </ng-container>
                                    </ng-container>
                                </tr>
                            </thead>
                            <ng-container>
                                <tbody *ngIf="table_data.length > 0">
                                    <ng-container *ngFor="let client of table_data | paginate : { id: 'interactions-data', itemsPerPage: pagination_records_limit, currentPage: current_pagination_page, totalItems: total_pagination_records }; let clientIndex = index">
                                        <tr>
                                            <td>
                                                <div class="record-selection-section">
                                                    <mat-checkbox [checked]="checkIndividualSelection(client)" (change)="selectIndividual($event, client)"></mat-checkbox>
                                                </div>
                                                <img src="assets/view-tasks.png" class="client-table-icon" (click)="showUserProfile(client)" style="margin-right: 4px;" [matTooltip]="'View Details'" />
                                            </td>
                                            <ng-container *ngFor="let column of table_columns" [ngSwitch]="column.key">
                                                <ng-container *ngSwitchCase="'advisor_status'">
                                                    <td *ngIf="column.checked">
                                                        <p class="status-tag completed-status">
                                                            {{ client.advisor_status }}
                                                        </p>
                                                    </td>
                                                </ng-container>
                                                <ng-container *ngSwitchCase="'ai_rank'">
                                                    <td class="highlight-table-cell" *ngIf="column.checked">
                                                        {{ getKey(client, column) }}
                                                    </td>
                                                </ng-container>
                                                <ng-container *ngSwitchCase="'risk_rank'">
                                                    <td class="highlight-table-cell" *ngIf="column.checked">
                                                    {{ getKey(client, column) }}
                                                    </td>
                                                </ng-container>
                                                <ng-container *ngSwitchCase="'opportunity'">
                                                    <td class="highlight-table-cell" *ngIf="column.checked">
                                                        {{ getKey(client, column) }}
                                                    </td>
                                                </ng-container>
                                                <ng-container *ngSwitchCase="'total_estimated_loss'">
                                                    <td class="highlight-table-cell" *ngIf="column.checked">
                                                        {{ getKey(client, column) }}
                                                    </td>
                                                </ng-container>
                                                <ng-container *ngSwitchCase="'predicted_wallet_share_growth'">
                                                    <td class="highlight-table-cell" *ngIf="column.checked">
                                                        {{ getKey(client, column) }}
                                                    </td>
                                                </ng-container>
                                                <ng-container *ngSwitchCase="'predicted_closure_days'">
                                                    <td class="highlight-table-cell" *ngIf="column.checked">
                                                        {{ getKey(client, column) }} Day(s)
                                                    </td>
                                                </ng-container>
                                                <ng-container *ngSwitchCase="'recommended_products'">
                                                    <td class="highlight-table-cell" *ngIf="column.checked" [matTooltip]="getKey(client, column)">
                                                        {{ getKey(client, column) }}
                                                    </td>
                                                </ng-container>
                                                <ng-container *ngSwitchCase="'preferred_channel'">
                                                    <td class="highlight-table-cell" *ngIf="column.checked" [matTooltip]="getKey(client, column)">
                                                        {{ getKey(client, column) }}
                                                    </td>
                                                </ng-container>

                                                <ng-container *ngSwitchCase="'trigger'">
                                                    <td *ngIf="column.checked">
                                                    <span [style.color]="client['trigger_type'] == 'AI' ? '#f3a638' : '#4cb64c'">{{ getKey(client, column) }}</span>
                                                    </td>
                                                </ng-container>

                                                <ng-container *ngSwitchCase="'type'">
                                                    <td *ngIf="column.checked" [matTooltip]="getKey(client, column)">
                                                        <span [ngClass]="{'need-attention-activity-status': getKey(client, column) == 'Retention', 'new-leads-activity-status': getKey(client, column) == 'Client Engagement', 'in-progress-activity-status': getKey(client, column) == 'Opportunity'}">{{getKey(client, column)}}</span>
                                                    </td>
                                                </ng-container>

                                                <ng-container *ngSwitchDefault>
                                                    <td *ngIf="column.checked">
                                                        {{ getKey(client, column) }}
                                                    </td>
                                                </ng-container>
                                            </ng-container>
                                        </tr>
                                    </ng-container>
                                </tbody>
                                <tbody *ngIf="table_data.length == 0">
                                    <td colspan="15">
                                        <div class="new-table-v2-zero-section">
                                            <!-- <img src="assets/no-data-table.png" /> -->
                                            <p class="new-table-v2-zero-label">No Data Found</p>
                                        </div>
                                    </td>
                                </tbody>
                            </ng-container>
                        </table>
                    </div>
                                    

                    <div class="new-table-v2-pagination-section">
                        <span class="mr-4">{{ total_pagination_records | number:'1.0-0' }} Records</span>
                        <ng-container *ngIf="table_data.length > 0">
                            <mat-select class="pagination-input" [(ngModel)]="pagination_records_limit" (selectionChange)="current_pagination_page = 1; viewAdvisorTeam(selected_advisor_team, selected_advisor_team_type)">
                                <mat-option [value]="10">10</mat-option>
                                <mat-option [value]="100">100</mat-option>
                                <mat-option [value]="500">500</mat-option>
                                <mat-option [value]="1000">1000</mat-option>
                            </mat-select>
                            <div class="new-table-v2-pagination-controls">
                                <pagination-controls id="interactions-data" (pageChange)="pageChanged($event)" style="text-align: right; position: relative; top: 6px" ></pagination-controls>
                            </div>
                        </ng-container>
                    </div>

                </div>
            </div>
        </div>
    </ng-container>
    <ng-container *ngIf="!selected_view_team_data_loaded">
        <app-loader [loading_text]="'Loading Advisor Team Data'"></app-loader>
    </ng-container>
</ng-container>


<ng-container *ngIf="show_user_profile">
	<ng-container>
		<ng-container *ngIf="user_profile_data.source_type_id != 1 ">
			<app-lead-profile [data]="user_profile_data" (profileClosed)="profileClosed($event)"></app-lead-profile>
		  </ng-container>
		  <ng-container *ngIf="user_profile_data.source_type_id == 1 ">
			<app-bank-customer-profile [data]="user_profile_data" (profileClosed)="profileClosed($event)"></app-bank-customer-profile>
		  </ng-container>
	</ng-container>
</ng-container>

<ng-template #moveRecordModal>
	<div class="page-modal-section">
		<div class="modal-heading-section client-view-heading-section">
			<span class="modal-heading">Unassign Prospects</span>
			<span class="client-modal-icon" (click)="closeMoveRecordModal()">&times;</span>
		</div>
		<div class="modal-content-section">
			<p class="page-modal-delete-description">Are you sure you want to Unassign?</p>
		</div>
		<div class="modal-footer-section">
            <ng-container *ngIf="!unassign_prospects_loader">
                <button class="page-modal-primary-button" (click)="unassignProspects()">Yes</button>
                <button class="page-modal-secondary-button" (click)="closeMoveRecordModal()">No</button>
            </ng-container>
            <ng-container *ngIf="unassign_prospects_loader">
                <button class="page-modal-primary-button">Processing...</button>
            </ng-container>
		</div>
	</div>
</ng-template>

<ng-template #createAdvisorTeamModal>
	<div class="page-modal-section">
		<div class="page-modal-heading-section client-view-heading-section">
			<span class="modal-heading">{{selected_advisor_team_type}} Advisor Team</span>
			<span class="page-modal-close-icon" (click)="closeCreateAdvisorTeamModal()">&times;</span>
		</div>
		<div class="page-modal-content-section">
			<ng-container>
				<div class="page-modal-input-section">
					<p class="page-modal-input-label">Team Name *</p>
					<input type="text" class="page-modal-input" [(ngModel)]="selected_advisor_team.name" />
					<p class="page-modal-input-error" *ngIf="selected_advisor_team_errors.name">Team Name is required</p>
				</div>
				<div class="page-modal-input-section">
					<p class="page-modal-input-label">Description </p>
					<textarea class="page-modal-input page-modal-textarea" [(ngModel)]="selected_advisor_team.description"></textarea>
					<p class="page-modal-input-error" *ngIf="selected_advisor_team_errors.description">Description is required</p>
				</div>
				<div class="page-modal-input-section">
					<p class="page-modal-input-label">Primary Advisor *</p>
					<mat-select class="page-modal-input"  [(ngModel)]="selected_advisor_team.primary_advisor_id" (selectionChange)="segregateOtherAdvisors()" [disabled]="selected_advisor_team_type == 'Edit'">
						<mat-option [value]="''">Select Primary Advisor</mat-option>
						<mat-option *ngFor="let advisor of advisor_list" [value]="advisor.id">{{advisor.first_name}} {{advisor.last_name}} : (Remaining Capacity - {{advisor.capacity_remaining}})</mat-option>
					</mat-select>
					<p class="page-modal-input-error" *ngIf="selected_advisor_team_errors.primary_advisor_id">Primary Advisor is required.</p>
				</div>
				<div class="page-modal-input-section">
					<p class="page-modal-input-label">Primary Advisor Share(%) *</p>
					<input type="text" class="page-modal-input" [(ngModel)]="selected_advisor_team.share_percentage" (keypress)="numberOnly($event)" />
					<p class="page-modal-input-error" *ngIf="selected_advisor_team_errors.share_percentage">Primary Advisor Share(%) is required & should be equal to 100.</p>
				</div>
				<ng-container *ngIf="selected_advisor_team.primary_advisor_id != ''">
					<div class="other-advisors-heading-section">
						<span>Other Advisors</span>
					</div>
					<p class="page-modal-input-error" *ngIf="selected_advisor_team_errors.all_members">Select at least one advisor, and enter a share(%) should be equal to 100.</p>
					<table class="page-inner-table">
						<thead>
							<tr>
								<th>Advisor</th>
								<th>Share(%)</th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let advisor of selected_advisor_team.all_members">
								<td>
									<mat-checkbox [(ngModel)]="advisor.checked" >{{advisor.advisor_name}}</mat-checkbox>
								</td>
								<td>
									<input type="text" class="page-modal-input" [(ngModel)]="advisor.share_percentage" (keypress)="numberOnly($event)" [disabled]="!advisor.checked" />
								</td>
							</tr>
						</tbody>
					</table>
				</ng-container>
			</ng-container>
			
		</div>
		<div class="page-modal-footer-section">
			<ng-container *ngIf="!assign_advisor_team_loader">
				<button class="page-modal-primary-button" (click)="assignAdvisorTeam()">Save</button>
				<button class="page-modal-secondary-button" (click)="closeCreateAdvisorTeamModal()">Cancel</button>
			</ng-container>
			<ng-container *ngIf="assign_advisor_team_loader">
				<button class="page-modal-primary-button" (click)="assignAdvisorTeam()">Saving...</button>
			</ng-container>
		</div>
	</div>
</ng-template>


<ng-template #deleteModal>
    <div class="page-modal-section">
        <div class="page-modal-heading-section">
            <span>Delete Advisor Team Details</span>
            <span class="page-modal-close-icon" (click)="closeDeleteModal()">&times;</span>
        </div>
        <div class="page-modal-content-section">
            <p class="page-modal-delete-description">Are you sure you want to delete?</p>
        </div>
        <div class="page-modal-footer-section">
            <button class="page-modal-primary-button" (click)="deleteRecord()">Yes</button>
            <button class="page-modal-secondary-button" (click)="closeDeleteModal()">No</button>
        </div>
    </div>
</ng-template>
